import { render, staticRenderFns } from "./MTable.vue?vue&type=template&id=3d3c379c&scoped=true"
import script from "./MTable.vue?vue&type=script&lang=js"
export * from "./MTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c379c",
  null
  
)

export default component.exports